function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../index';
import { Dropdown, DropdownItem } from '../Dropdown/Dropdown';
import { NavLink } from 'react-router-dom';
import { matchPath } from 'react-router';
import { useLocation } from 'react-router-dom';

const NavItem = ({
  icon,
  iconSize = 14,
  isMenuOverlayed = true,
  label,
  sublinks,
  to,
  ...rest
}) => {
  const location = useLocation();
  return sublinks ? /*#__PURE__*/React.createElement(Dropdown, _extends({
    isActive: matchPath(location.pathname, to),
    isMenuOverlayed: isMenuOverlayed
  }, rest), sublinks.map(({
    to,
    icon,
    label
  }) => /*#__PURE__*/React.createElement(DropdownItem, {
    key: to,
    icon: icon,
    to: to
  }, label))) : /*#__PURE__*/React.createElement(NavLink, _extends({
    exact: true,
    activeClassName: "nav-item--active",
    to: to
  }, rest), /*#__PURE__*/React.createElement(Button, {
    version: "text",
    isReverse: true,
    label: label,
    icon: icon,
    iconSize: iconSize
  }));
};

NavItem.propTypes = {
  to: PropTypes.string.isRequired,
  sublinks: PropTypes.arrayOf({
    to: PropTypes.string.isRequired,
    icon: PropTypes.string,
    label: PropTypes.string
  }),
  label: PropTypes.string,
  icon: PropTypes.string,
  description: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
};
export default NavItem;